<div class="landing-page">
  <!-- Hero Section -->
  <section class="hero">
    <div class="container">
      <div class="hero-content">
        <h1 class="hero-title">Bienvenido a <span class="brand">PanaKYC</span></h1>
        <p class="hero-subtitle">Plataforma moderna de KYC y gestion de cumplimiento</p>
        <p class="hero-description">
          Simplifique sus procesos de Conozca a su Cliente con una plataforma integral creada para
          empresas y organizaciones en Panama y mas alla.
        </p>
        <div class="hero-actions">
          <button class="btn btn-secondary" type="button">Mas informacion</button>
          <button class="btn btn-primary" type="button" routerLink="/login">Comenzar</button>
          <a
            class="btn btn-secondary"
            role="button"
            routerLink="/dashboard/kyc"
            aria-label="Abrir panel KYC"
            >Ver Dashboard</a
          >
        </div>
      </div>
    </div>
  </section>

  <!-- Features Section -->
  <section class="features" aria-labelledby="features-title">
    <div class="container">
      <h2 id="features-title" class="section-title">
        Funciones potentes para un cumplimiento total
      </h2>
      <div class="features-grid">
        @for (feature of features; track feature.title) {
          <article class="feature-card">
            <div class="feature-icon icon" aria-hidden="true">{{ feature.icon }}</div>
            <h3 class="feature-title">{{ feature.title }}</h3>
            <p class="feature-description">{{ feature.description }}</p>
          </article>
        }
      </div>
    </div>
  </section>

  <!-- Benefits Section -->
  <section class="benefits" aria-labelledby="benefits-title">
    <div class="container">
      <h2 id="benefits-title" class="section-title">Por que elegir PanaKYC?</h2>
      <div class="benefits-content">
        <div class="benefit-item">
          <div class="benefit-number">01</div>
          <h3>Cumplimiento automatizado</h3>
          <p>Reduzca el trabajo manual con automatizacion y flujos inteligentes</p>
        </div>
        <div class="benefit-item">
          <div class="benefit-number">02</div>
          <h3>Monitoreo en tiempo real</h3>
          <p>Mantengase informado con alertas y actualizaciones inmediatas</p>
        </div>
        <div class="benefit-item">
          <div class="benefit-number">03</div>
          <h3>Seguro y escalable</h3>
          <p>Seguridad de nivel empresarial con escalabilidad sin limites</p>
        </div>
        <div class="benefit-item">
          <div class="benefit-number">04</div>
          <h3>Integracion sencilla</h3>
          <p>Integre facilmente con sus sistemas existentes</p>
        </div>
      </div>
    </div>
  </section>

  <!-- CTA Section -->
  <section class="cta" aria-labelledby="cta-title">
    <div class="container">
      <h2 id="cta-title" class="cta-title">Listo para transformar su proceso de KYC?</h2>
      <p class="cta-description">
        Unase a las organizaciones que ya usan PanaKYC para sus necesidades de cumplimiento
      </p>
      <button
        class="btn btn-primary btn-large"
        type="button"
        aria-label="Comience su prueba gratis"
      >
        Comience su prueba gratis
      </button>
    </div>
  </section>

  <!-- Footer -->
  <footer class="footer" role="contentinfo">
    <div class="container">
      <p>&copy; 2026 PanaKYC. Todos los derechos reservados.</p>
    </div>
  </footer>
</div>
